"use strict";

var generated = Object.create(null), random = Math.random;

module.exports = function () {
	var str;
	do {
		str = random().toString(36).slice(2);
	} while (generated[str]);
	return str;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/string/random-uniq.js
// module id = T7At
// module chunks = 0